import React from "react";
import cj from './cj.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export function PreviewBox ({src, onClick, charCount, hasMultipleImages}) {
    

	return (
		<div className="main">
			<div className="App-header">
				<img width={50} height={50} src={cj} alt="Circlejourney logo" />
				Circlejourney's interactive commission sheet
			</div>
			
			<div
				className={ src ? "preview-wrapper" : "preview-wrapper preview-empty" }
				style={
					{ "backgroundImage": "url("+ src +")" }
				}
			>
				<div className="preview-overlay">
					{
						!src ? (
							<h2>Select a style and size</h2>
						): (
							<>
								<img 
									src={src}
									className="preview-image"
									onClick={onClick}
									alt="Commission preview"
								/>
								<div className="preview-note">
									{hasMultipleImages ? "Click to view more examples" : "Click to enlarge" }
								</div>
							</>
						)
					}
					{
						charCount > 1 && src ? (
							<div className="character-counter">
								<FontAwesomeIcon icon="user" /> {charCount}
							</div>
						) : ""
					}
				</div>
			</div>
			
		</div>
	);	
}